// @owners { team: patients }
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { queries } from '~shared/queries/query-keys';
import { useQuery } from '~shared/react-query';
import { useSelectorShared } from '~shared/store';
import { onboardingBackgroundColor } from '../helpers/onboardingBackgroundColor';

export const useQueryPhiAuthorizationConfigs = () => {
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);
  const { isFetching, isError, isSuccess, data } = useQuery({
    ...queries.onboardingConfigs.fetchPhiAuthorization({ params: {} }),
  });

  const partnershipName = data?.data?.partnership_name;
  const headerBackgroundColor = onboardingBackgroundColor(partnershipName, showProgyny);

  return {
    partnershipName,
    isFetching,
    isError,
    isSuccess,
    headerBackgroundColor,
    headerLogoUrl: data?.data?.header_logo_url,
  };
};
